import { asTimeFormat, clockOptions, formatClock, type TimeFormat } from '@ehr/shared';
import { to24h } from './apptLink.js';

/**
 * ehr#98 - the signed-in person's own time format (set on their own profile), applied to every time shown
 * on an internal screen. The session sets it from /auth/me; a change re-renders the app, so each
 * display picks it up on its next render. Time inputs and pickers stay AM/PM (the spec).
 */
let personal: TimeFormat = '12h';

export function setPersonalTimeFormat(f: unknown): void {
  personal = asTimeFormat(f);
}

export const personalTimeFormat = (): TimeFormat => personal;

/** Intl options for the clock part ("6:30 PM" or "18:30"), to spread into toLocaleString. */
export const timeOpts = (): Intl.DateTimeFormatOptions => clockOptions(personal);

/** The time of day of `at` in the person's format: "6:30 PM" or "18:30". */
export const clockTime = (at: Date | string): string => formatClock(at, personal);

/**
 * ehr#407 - a time saved as text ("3:00 PM": a note's session time, a group attendee's arrival) in the
 * person's format: "15:00" on 24-hour. What's saved doesn't change; text that isn't a time shows as is.
 */
export const storedTime = (t: string): string => (personal === '24h' && to24h(t)) || t;
